import React, { FunctionComponent, useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ContentPageItemCollection } from "services/entities/content";
import { DynamicImageSizes } from "../../services/entities/content";

type DynamicImageProps = {
  item: DynamicImageSizes | any;
};

export const DynamicImage: FunctionComponent<DynamicImageProps> = ({
  item,
}) => {
  const [imageSize, setImageSize] = useState("xl");
  useEffect(() => {
    const updateMedia = () => {
      if (window.innerWidth < 500) {
        setImageSize("sm");
        return;
      } else if (window.innerWidth > 500 && window.innerWidth < 800) {
        setImageSize("md");
        return;
      } else if (window.innerWidth > 800 && window.innerWidth < 1024) {
        setImageSize("lg");
        return;
      } else {
        setImageSize("xl");
        return;
      }
    };
    updateMedia();
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  // ? Might be worth using the context provider here.
  // const { todos, updateTodo } = useContext(TodoContext) as ContextType
  return (
    <>
      {imageSize && (item as ContentPageItemCollection)[imageSize] ? (
        <div className="image-wrapper">
          <LazyLoadImage
            src={
              ((item as ContentPageItemCollection)[imageSize] as URL) &&
              (
                (item as ContentPageItemCollection)[imageSize] as URL
              ).href.toString()
            }
            effect="blur"
            alt="banner of Sook shop"
          />
        </div>
      ) : (
        item &&
        item.hasOwnProperty("xl") && (
          <div className="image-wrapper">
            <LazyLoadImage
              src={
                ((item as ContentPageItemCollection)["xl"] as URL) &&
                (
                  (item as ContentPageItemCollection)["xl"] as URL
                ).href.toString()
              }
              alt="banner of Sook"
            />
          </div>
        )
      )}
    </>
  );
};

export default DynamicImage;
